//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealthClamav(): Promise<void> {
        let url_ = this.baseUrl + "/health/clamav";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealthClamav(_response);
        });
    }

    protected processGetHealthClamav(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDiagPositionRules(): Promise<void> {
        let url_ = this.baseUrl + "/_diag/position-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiagPositionRules(_response);
        });
    }

    protected processGetDiagPositionRules(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppointmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getApiAppointments(status: BookingStatus | null | undefined, from: Date | null | undefined, to: Date | null | undefined, pageNumber: number, pageSize: number): Promise<PaginatedListOfOrganizationBookingDto> {
        let url_ = this.baseUrl + "/api/Appointments?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAppointments(_response);
        });
    }

    protected processGetApiAppointments(response: Response): Promise<PaginatedListOfOrganizationBookingDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOrganizationBookingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOrganizationBookingDto>(null as any);
    }

    getApiAppointments2(id: number): Promise<AppointmentDetailDto> {
        let url_ = this.baseUrl + "/api/Appointments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAppointments2(_response);
        });
    }

    protected processGetApiAppointments2(response: Response): Promise<AppointmentDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentDetailDto>(null as any);
    }

    postApiAppointmentsConfirm(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointments/{id}/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAppointmentsConfirm(_response);
        });
    }

    protected processPostApiAppointmentsConfirm(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiAppointmentsCancel(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointments/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAppointmentsCancel(_response);
        });
    }

    protected processPostApiAppointmentsCancel(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganizationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postApiOrganizations(command: CreateOrganizationCommand): Promise<OrganizationDto> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiOrganizations(_response);
        });
    }

    protected processPostApiOrganizations(response: Response): Promise<OrganizationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto>(null as any);
    }

    getApiOrganizations(keyword: string | null | undefined, isActive: boolean | null | undefined, includeDeleted: boolean | null | undefined, from: Date | null | undefined, to: Date | null | undefined, pageNumber: number, pageSize: number): Promise<PaginatedListOfOrganizationDto> {
        let url_ = this.baseUrl + "/api/organizations?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizations(_response);
        });
    }

    protected processGetApiOrganizations(response: Response): Promise<PaginatedListOfOrganizationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOrganizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOrganizationDto>(null as any);
    }

    putApiOrganizations(id: number, command: UpdateOrganizationCommand): Promise<OrganizationDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiOrganizations(_response);
        });
    }

    protected processPutApiOrganizations(response: Response): Promise<OrganizationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto>(null as any);
    }

    deleteApiOrganizations(id: number): Promise<DeleteOrganizationResult> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiOrganizations(_response);
        });
    }

    protected processDeleteApiOrganizations(response: Response): Promise<DeleteOrganizationResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteOrganizationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteOrganizationResult>(null as any);
    }

    patchApiOrganizationsActivate(id: number, request: ToggleStatusRequest): Promise<OrganizationDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchApiOrganizationsActivate(_response);
        });
    }

    protected processPatchApiOrganizationsActivate(response: Response): Promise<OrganizationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto>(null as any);
    }

    postApiOrganizationsLink(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/organizations/{id}/link";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiOrganizationsLink(_response);
        });
    }

    protected processPostApiOrganizationsLink(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    postApiOrganizationsLinkReset(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/organizations/{id}/link/reset";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiOrganizationsLinkReset(_response);
        });
    }

    protected processPostApiOrganizationsLinkReset(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    getApiOrganizationsLinkToken(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/organizations/{id}/link/token";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizationsLinkToken(_response);
        });
    }

    protected processGetApiOrganizationsLinkToken(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    patchApiOrganizationsLinkEnable(id: number): Promise<OrganizationLinkDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}/link/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchApiOrganizationsLinkEnable(_response);
        });
    }

    protected processPatchApiOrganizationsLinkEnable(response: Response): Promise<OrganizationLinkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationLinkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationLinkDto>(null as any);
    }

    patchApiOrganizationsLinkDisable(id: number): Promise<OrganizationLinkDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}/link/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchApiOrganizationsLinkDisable(_response);
        });
    }

    protected processPatchApiOrganizationsLinkDisable(response: Response): Promise<OrganizationLinkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationLinkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationLinkDto>(null as any);
    }

    getApiOrganizationsStats(id: number, from: Date | null | undefined, to: Date | null | undefined, groupBy: string | null | undefined): Promise<OrganizationStatsDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}/stats?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (groupBy !== undefined && groupBy !== null)
            url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizationsStats(_response);
        });
    }

    protected processGetApiOrganizationsStats(response: Response): Promise<OrganizationStatsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationStatsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationStatsDto>(null as any);
    }

    getApiOrganizationsAppointments(id: number, organizationId: number, status: BookingStatus | null | undefined, from: Date | null | undefined, to: Date | null | undefined, pageNumber: number, pageSize: number): Promise<PaginatedListOfOrganizationBookingDto> {
        let url_ = this.baseUrl + "/api/organizations/{id}/appointments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined and cannot be null.");
        else
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizationsAppointments(_response);
        });
    }

    protected processGetApiOrganizationsAppointments(response: Response): Promise<PaginatedListOfOrganizationBookingDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOrganizationBookingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOrganizationBookingDto>(null as any);
    }

    getApiOrganizationsExport(id: number, organizationId: number, status: BookingStatus | null | undefined, from: Date | null | undefined, to: Date | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/export?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined and cannot be null.");
        else
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizationsExport(_response);
        });
    }

    protected processGetApiOrganizationsExport(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postApiAuthAuthLogin(req: LoginRequest): Promise<LoginResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAuthAuthLogin(_response);
        });
    }

    protected processPostApiAuthAuthLogin(response: Response): Promise<LoginResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponseDto>(null as any);
    }

    postApiAuthAuthRefresh(): Promise<LoginResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAuthAuthRefresh(_response);
        });
    }

    protected processPostApiAuthAuthRefresh(response: Response): Promise<LoginResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponseDto>(null as any);
    }

    postApiAuthAuthLogout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAuthAuthLogout(_response);
        });
    }

    protected processPostApiAuthAuthLogout(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CaptchaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCaptchaImage(scope: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Captcha/{scope}";
        if (scope === undefined || scope === null)
            throw new Error("The parameter 'scope' must be defined.");
        url_ = url_.replace("{scope}", encodeURIComponent("" + scope));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptchaImage(_response);
        });
    }

    protected processGetCaptchaImage(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ClinicsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDoctors(clinicId: number): Promise<DoctorWithScheduleDto[]> {
        let url_ = this.baseUrl + "/api/Clinics/{clinicId}/doctors";
        if (clinicId === undefined || clinicId === null)
            throw new Error("The parameter 'clinicId' must be defined.");
        url_ = url_.replace("{clinicId}", encodeURIComponent("" + clinicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctors(_response);
        });
    }

    protected processGetDoctors(response: Response): Promise<DoctorWithScheduleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorWithScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorWithScheduleDto[]>(null as any);
    }

    getAvailableSlots(clinicId: number): Promise<ClinicAvailableSlotDto> {
        let url_ = this.baseUrl + "/api/Clinics/{clinicId}/available-slots";
        if (clinicId === undefined || clinicId === null)
            throw new Error("The parameter 'clinicId' must be defined.");
        url_ = url_.replace("{clinicId}", encodeURIComponent("" + clinicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSlots(_response);
        });
    }

    protected processGetAvailableSlots(response: Response): Promise<ClinicAvailableSlotDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicAvailableSlotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicAvailableSlotDto>(null as any);
    }

    postApiClinics(clinicId: number, cmd: UpdateClinicInfoCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Clinics/{clinicId}";
        if (clinicId === undefined || clinicId === null)
            throw new Error("The parameter 'clinicId' must be defined.");
        url_ = url_.replace("{clinicId}", encodeURIComponent("" + clinicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiClinics(_response);
        });
    }

    protected processPostApiClinics(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    postApiClinicsImage(clinicId: string, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Clinics/{clinicId}/image";
        if (clinicId === undefined || clinicId === null)
            throw new Error("The parameter 'clinicId' must be defined.");
        url_ = url_.replace("{clinicId}", encodeURIComponent("" + clinicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiClinicsImage(_response);
        });
    }

    protected processPostApiClinicsImage(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteApiClinicsImage(clinicId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Clinics/{clinicId}/image/remove";
        if (clinicId === undefined || clinicId === null)
            throw new Error("The parameter 'clinicId' must be defined.");
        url_ = url_.replace("{clinicId}", encodeURIComponent("" + clinicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiClinicsImage(_response);
        });
    }

    protected processDeleteApiClinicsImage(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DoctorAppointmentRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createDoctorAppointmentRequest(command: CreateDoctorAppointmentRequestCommand): Promise<ResultOfInteger> {
        let url_ = this.baseUrl + "/api/DoctorAppointmentRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDoctorAppointmentRequest(_response);
        });
    }

    protected processCreateDoctorAppointmentRequest(response: Response): Promise<ResultOfInteger> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfInteger>(null as any);
    }

    getDoctorAppointmentRequests(): Promise<DoctorAppointmentRequestDto[]> {
        let url_ = this.baseUrl + "/api/DoctorAppointmentRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctorAppointmentRequests(_response);
        });
    }

    protected processGetDoctorAppointmentRequests(response: Response): Promise<DoctorAppointmentRequestDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorAppointmentRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorAppointmentRequestDto[]>(null as any);
    }

    getDoctorAppointmentRequestById(id: number): Promise<DoctorAppointmentRequestDto> {
        let url_ = this.baseUrl + "/api/DoctorAppointmentRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctorAppointmentRequestById(_response);
        });
    }

    protected processGetDoctorAppointmentRequestById(response: Response): Promise<DoctorAppointmentRequestDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorAppointmentRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorAppointmentRequestDto>(null as any);
    }

    updateDoctorAppointmentRequestStatus(id: number, command: UpdateDoctorAppointmentRequestStatusCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/DoctorAppointmentRequests/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDoctorAppointmentRequestStatus(_response);
        });
    }

    protected processUpdateDoctorAppointmentRequestStatus(response: Response): Promise<Result> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateActualAppointmentDate(id: number, command: UpdateActualAppointmentDateCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/DoctorAppointmentRequests/{id}/actual-appointment-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateActualAppointmentDate(_response);
        });
    }

    protected processUpdateActualAppointmentDate(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DoctorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postApiDoctorsImage(doctorId: string, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Doctors/{doctorId}/image";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiDoctorsImage(_response);
        });
    }

    protected processPostApiDoctorsImage(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    createDoctorTitle(command: CreateDoctorTitleCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Doctors/titles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDoctorTitle(_response);
        });
    }

    protected processCreateDoctorTitle(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateDoctorTitle(id: number, command: UpdateDoctorTitleCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Doctors/titles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDoctorTitle(_response);
        });
    }

    protected processUpdateDoctorTitle(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    upsertDoctorProfileSetting(command: UpsertDoctorProfileSettingCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Doctors/profile-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsertDoctorProfileSetting(_response);
        });
    }

    protected processUpsertDoctorProfileSetting(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteDoctorImage(doctorId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Doctors/{doctorId}/image/remove";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDoctorImage(_response);
        });
    }

    protected processDeleteDoctorImage(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDoctors(date: string | null | undefined, searchTerm: string | null | undefined, available: boolean | null | undefined, onlyConfigRoom: boolean | null | undefined, roomId: number | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<DoctorsResponseDto> {
        let url_ = this.baseUrl + "/api/Doctors?";
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (available !== undefined && available !== null)
            url_ += "Available=" + encodeURIComponent("" + available) + "&";
        if (onlyConfigRoom !== undefined && onlyConfigRoom !== null)
            url_ += "OnlyConfigRoom=" + encodeURIComponent("" + onlyConfigRoom) + "&";
        if (roomId !== undefined && roomId !== null)
            url_ += "RoomId=" + encodeURIComponent("" + roomId) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctors(_response);
        });
    }

    protected processGetDoctors(response: Response): Promise<DoctorsResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorsResponseDto>(null as any);
    }

    getDoctorProfile(doctorId: string): Promise<DoctorDto> {
        let url_ = this.baseUrl + "/api/Doctors/{doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctorProfile(_response);
        });
    }

    protected processGetDoctorProfile(response: Response): Promise<DoctorDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorDto>(null as any);
    }

    getAvailableTimes(doctorId: string): Promise<DoctorScheduleClinicDto> {
        let url_ = this.baseUrl + "/api/Doctors/{doctorId}/available-times";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableTimes(_response);
        });
    }

    protected processGetAvailableTimes(response: Response): Promise<DoctorScheduleClinicDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorScheduleClinicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorScheduleClinicDto>(null as any);
    }

    streamAvatars(batchId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Doctors/avatars/stream?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStreamAvatars(_response);
        });
    }

    protected processStreamAvatars(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDoctorTitles(): Promise<DoctorTitleOptionDto[]> {
        let url_ = this.baseUrl + "/api/Doctors/titles/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoctorTitles(_response);
        });
    }

    protected processGetDoctorTitles(response: Response): Promise<DoctorTitleOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorTitleOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoctorTitleOptionDto[]>(null as any);
    }
}

export class LookupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLookupsBundle(): Promise<LookupBundleDto> {
        let url_ = this.baseUrl + "/api/Lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookupsBundle(_response);
        });
    }

    protected processGetLookupsBundle(response: Response): Promise<LookupBundleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupBundleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupBundleDto>(null as any);
    }

    getDistricts(provinceId: number): Promise<DistrictDto[]> {
        let url_ = this.baseUrl + "/api/Lookups/provinces/{provinceId}/districts";
        if (provinceId === undefined || provinceId === null)
            throw new Error("The parameter 'provinceId' must be defined.");
        url_ = url_.replace("{provinceId}", encodeURIComponent("" + provinceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistricts(_response);
        });
    }

    protected processGetDistricts(response: Response): Promise<DistrictDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistrictDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistrictDto[]>(null as any);
    }

    getWards(provinceId: number): Promise<WardDto[]> {
        let url_ = this.baseUrl + "/api/Lookups/districts/{provinceId}/wards";
        if (provinceId === undefined || provinceId === null)
            throw new Error("The parameter 'provinceId' must be defined.");
        url_ = url_.replace("{provinceId}", encodeURIComponent("" + provinceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWards(_response);
        });
    }

    protected processGetWards(response: Response): Promise<WardDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WardDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WardDto[]>(null as any);
    }

    searchRevisit(query: SearchRevisitQuery): Promise<RevisitDto> {
        let url_ = this.baseUrl + "/api/Lookups/revisit/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchRevisit(_response);
        });
    }

    protected processSearchRevisit(response: Response): Promise<RevisitDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisitDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevisitDto>(null as any);
    }
}

export class Organization_LinksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getApiOrganizationLinkResolve(token: string): Promise<OrganizationLinkResolveDto> {
        let url_ = this.baseUrl + "/api/organization-link/resolve?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOrganizationLinkResolve(_response);
        });
    }

    protected processGetApiOrganizationLinkResolve(response: Response): Promise<OrganizationLinkResolveDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationLinkResolveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationLinkResolveDto>(null as any);
    }
}

export class ScheduleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSchedules(clinicId: number | null | undefined, doctorId: string | null | undefined, fromDate: string, toDate: string): Promise<TimeRangeSlotDto[]> {
        let url_ = this.baseUrl + "/api/Schedule?";
        if (clinicId !== undefined && clinicId !== null)
            url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
        if (doctorId !== undefined && doctorId !== null)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedules(_response);
        });
    }

    protected processGetSchedules(response: Response): Promise<TimeRangeSlotDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeRangeSlotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeRangeSlotDto[]>(null as any);
    }

    createScheduleSlot(command: CreateScheduleSlotCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScheduleSlot(_response);
        });
    }

    protected processCreateScheduleSlot(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateScheduleSlot(scheduleId: number, command: UpdateScheduleSlotCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Schedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateScheduleSlot(_response);
        });
    }

    protected processUpdateScheduleSlot(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteScheduleSlot(scheduleId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Schedule/{scheduleId}/delete";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteScheduleSlot(_response);
        });
    }

    protected processDeleteScheduleSlot(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    checkScheduleConflict(query: CheckScheduleConflictQuery): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Schedule/check-conflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckScheduleConflict(_response);
        });
    }

    protected processCheckScheduleConflict(response: Response): Promise<string[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    updateTimeRangeSlot(command: UpdateScheduleSlotTimeRangeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Schedule/time-range";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTimeRangeSlot(_response);
        });
    }

    protected processUpdateTimeRangeSlot(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTimeRangeStatus(command: UpdateScheduleSlotTimeRangeStatusCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Schedule/time-range/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTimeRangeStatus(_response);
        });
    }

    protected processUpdateTimeRangeStatus(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTimeRangeSlot(command: DeleteScheduleSlotTimeRangeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Schedule/time-range/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTimeRangeSlot(_response);
        });
    }

    protected processDeleteTimeRangeSlot(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SpecialtiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createSpecialty(command: CreateSpecialtyCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Specialties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSpecialty(_response);
        });
    }

    protected processCreateSpecialty(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSpeciaties(): Promise<SpecialtyDto[]> {
        let url_ = this.baseUrl + "/api/Specialties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpeciaties(_response);
        });
    }

    protected processGetSpeciaties(response: Response): Promise<SpecialtyDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialtyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecialtyDto[]>(null as any);
    }

    updateSpecialty(id: number, command: UpdateSpecialtyCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Specialties/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSpecialty(_response);
        });
    }

    protected processUpdateSpecialty(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateDoctorSpecialty(doctorId: string, command: UpdateDoctorSpecialtyCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Specialties/doctors/{doctorId}/specialty";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDoctorSpecialty(_response);
        });
    }

    protected processUpdateDoctorSpecialty(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteSpecialty(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Specialties/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSpecialty(_response);
        });
    }

    protected processDeleteSpecialty(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getClinics(specialyId: number, excludeConfigRoom: boolean | null | undefined): Promise<ClinicScheduleStatusDto[]> {
        let url_ = this.baseUrl + "/api/Specialties/{specialyId}/clinics?";
        if (specialyId === undefined || specialyId === null)
            throw new Error("The parameter 'specialyId' must be defined.");
        url_ = url_.replace("{specialyId}", encodeURIComponent("" + specialyId));
        if (excludeConfigRoom !== undefined && excludeConfigRoom !== null)
            url_ += "excludeConfigRoom=" + encodeURIComponent("" + excludeConfigRoom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClinics(_response);
        });
    }

    protected processGetClinics(response: Response): Promise<ClinicScheduleStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicScheduleStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicScheduleStatusDto[]>(null as any);
    }

    getClinicsPaged(specialyId: number, pageNumber: number | null | undefined, pageSize: number | null | undefined, searchTerm: string | null | undefined): Promise<ClinicsResponseDto> {
        let url_ = this.baseUrl + "/api/Specialties/{specialyId}/clinics/paged?";
        if (specialyId === undefined || specialyId === null)
            throw new Error("The parameter 'specialyId' must be defined.");
        url_ = url_.replace("{specialyId}", encodeURIComponent("" + specialyId));
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClinicsPaged(_response);
        });
    }

    protected processGetClinicsPaged(response: Response): Promise<ClinicsResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicsResponseDto>(null as any);
    }
}

export class TicketsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createTicket(command: CreateTicketCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Tickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTicket(_response);
        });
    }

    protected processCreateTicket(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchTicket(query: SearchTicketQuery): Promise<SearchTicketView> {
        let url_ = this.baseUrl + "/api/Tickets/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchTicket(_response);
        });
    }

    protected processSearchTicket(response: Response): Promise<SearchTicketView> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTicketView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchTicketView>(null as any);
    }

    getTicket(id: string): Promise<TicketDto> {
        let url_ = this.baseUrl + "/api/Tickets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTicket(_response);
        });
    }

    protected processGetTicket(response: Response): Promise<TicketDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketDto>(null as any);
    }
}

export class AdminAccessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getApiAdminAccessDefinition(): Promise<AccessDefinitionDto> {
        let url_ = this.baseUrl + "/api/AdminAccess/definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAdminAccessDefinition(_response);
        });
    }

    protected processGetApiAdminAccessDefinition(response: Response): Promise<AccessDefinitionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessDefinitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessDefinitionDto>(null as any);
    }

    getApiAdminAccessUsersAccess(userId: string): Promise<UserAccessDto> {
        let url_ = this.baseUrl + "/api/AdminAccess/users/{userId}/access";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAdminAccessUsersAccess(_response);
        });
    }

    protected processGetApiAdminAccessUsersAccess(response: Response): Promise<UserAccessDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccessDto>(null as any);
    }

    putApiAdminAccessUsersAccess(userId: string, request: UpdateUserAccessRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/AdminAccess/users/{userId}/access";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiAdminAccessUsersAccess(_response);
        });
    }

    protected processPutApiAdminAccessUsersAccess(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AdminUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getApiAdminUsers(keyword: string | null | undefined, departmentId: number | null | undefined, page: number | undefined, size: number | undefined): Promise<PaginatedListOfAdminUserSummaryDto> {
        let url_ = this.baseUrl + "/api/AdminUsers?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAdminUsers(_response);
        });
    }

    protected processGetApiAdminUsers(response: Response): Promise<PaginatedListOfAdminUserSummaryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAdminUserSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAdminUserSummaryDto>(null as any);
    }

    postApiAdminUsers(request: CreateUserRequest): Promise<AdminUserDto> {
        let url_ = this.baseUrl + "/api/AdminUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiAdminUsers(_response);
        });
    }

    protected processPostApiAdminUsers(response: Response): Promise<AdminUserDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminUserDto>(null as any);
    }

    putApiAdminUsers(userId: string, request: UpdateUserRequest): Promise<AdminUserDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiAdminUsers(_response);
        });
    }

    protected processPutApiAdminUsers(response: Response): Promise<AdminUserDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminUserDto>(null as any);
    }

    deleteApiAdminUsers(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/AdminUsers/{userId}/delete";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiAdminUsers(_response);
        });
    }

    protected processDeleteApiAdminUsers(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    putApiAdminUsersPassword(userId: string, request: ResetUserPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/AdminUsers/{userId}/password";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiAdminUsersPassword(_response);
        });
    }

    protected processPutApiAdminUsersPassword(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    putApiAdminUsersClinics(userId: string, request: UpdateUserClinicsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/AdminUsers/{userId}/clinics";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiAdminUsersClinics(_response);
        });
    }

    protected processPutApiAdminUsersClinics(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RolesApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRoles(): Promise<RoleSummaryDto[]> {
        let url_ = this.baseUrl + "/api/RolesApi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<RoleSummaryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleSummaryDto[]>(null as any);
    }

    getRoleAccess(roleId: string): Promise<RoleAccessDto> {
        let url_ = this.baseUrl + "/api/RolesApi/{roleId}/access";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleAccess(_response);
        });
    }

    protected processGetRoleAccess(response: Response): Promise<RoleAccessDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleAccessDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleAccessDto>(null as any);
    }

    /**
     * @return OK
     */
    updateRoleAccess(roleId: string, req: UpdateRoleAccessRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/RolesApi/{roleId}/access";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRoleAccess(_response);
        });
    }

    protected processUpdateRoleAccess(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return null;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return null;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PaginatedListOfOrganizationBookingDto implements IPaginatedListOfOrganizationBookingDto {
    items?: OrganizationBookingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfOrganizationBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationBookingDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfOrganizationBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfOrganizationBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfOrganizationBookingDto {
    items?: OrganizationBookingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class OrganizationBookingDto implements IOrganizationBookingDto {
    id?: number;
    scheduleSlotId?: number | undefined;
    roomId?: number;
    patientKey?: string;
    organizationId?: number | undefined;
    date?: Date;
    timeband?: TimebandCode;
    status?: BookingStatus;
    hisAppointmentId?: number;
    created?: Date;
    lastModified?: Date;
    doctorId?: number | undefined;
    patientName?: string | undefined;
    patientPhone?: string | undefined;
    patientEmail?: string | undefined;
    reasonForVisit?: string | undefined;
    notes?: string | undefined;
    doctorName?: string | undefined;
    roomName?: string | undefined;
    appointmentTimeText?: string | undefined;
    timeDisplay?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IOrganizationBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduleSlotId = _data["scheduleSlotId"];
            this.roomId = _data["roomId"];
            this.patientKey = _data["patientKey"];
            this.organizationId = _data["organizationId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.timeband = _data["timeband"];
            this.status = _data["status"];
            this.hisAppointmentId = _data["hisAppointmentId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.patientName = _data["patientName"];
            this.patientPhone = _data["patientPhone"];
            this.patientEmail = _data["patientEmail"];
            this.reasonForVisit = _data["reasonForVisit"];
            this.notes = _data["notes"];
            this.doctorName = _data["doctorName"];
            this.roomName = _data["roomName"];
            this.appointmentTimeText = _data["appointmentTimeText"];
            this.timeDisplay = _data["timeDisplay"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): OrganizationBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduleSlotId"] = this.scheduleSlotId;
        data["roomId"] = this.roomId;
        data["patientKey"] = this.patientKey;
        data["organizationId"] = this.organizationId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["timeband"] = this.timeband;
        data["status"] = this.status;
        data["hisAppointmentId"] = this.hisAppointmentId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["patientName"] = this.patientName;
        data["patientPhone"] = this.patientPhone;
        data["patientEmail"] = this.patientEmail;
        data["reasonForVisit"] = this.reasonForVisit;
        data["notes"] = this.notes;
        data["doctorName"] = this.doctorName;
        data["roomName"] = this.roomName;
        data["appointmentTimeText"] = this.appointmentTimeText;
        data["timeDisplay"] = this.timeDisplay;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IOrganizationBookingDto {
    id?: number;
    scheduleSlotId?: number | undefined;
    roomId?: number;
    patientKey?: string;
    organizationId?: number | undefined;
    date?: Date;
    timeband?: TimebandCode;
    status?: BookingStatus;
    hisAppointmentId?: number;
    created?: Date;
    lastModified?: Date;
    doctorId?: number | undefined;
    patientName?: string | undefined;
    patientPhone?: string | undefined;
    patientEmail?: string | undefined;
    reasonForVisit?: string | undefined;
    notes?: string | undefined;
    doctorName?: string | undefined;
    roomName?: string | undefined;
    appointmentTimeText?: string | undefined;
    timeDisplay?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export enum TimebandCode {
    AM = 1,
    PM = 2,
}

export enum BookingStatus {
    Held = 0,
    Confirmed = 1,
    Cancelled = 2,
}

export class AppointmentDetailDto implements IAppointmentDetailDto {
    id?: number;
    patientKey?: string;
    clinicId?: number;
    scheduleSlotId?: number | undefined;
    doctorId?: number | undefined;
    organizationId?: number | undefined;
    date?: Date;
    timeband?: TimebandCode;
    scope?: BookingScope;
    status?: BookingStatus;
    holdExpiresAt?: Date | undefined;
    hisAppointmentId?: number;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IAppointmentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientKey = _data["patientKey"];
            this.clinicId = _data["clinicId"];
            this.scheduleSlotId = _data["scheduleSlotId"];
            this.doctorId = _data["doctorId"];
            this.organizationId = _data["organizationId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.timeband = _data["timeband"];
            this.scope = _data["scope"];
            this.status = _data["status"];
            this.holdExpiresAt = _data["holdExpiresAt"] ? new Date(_data["holdExpiresAt"].toString()) : <any>undefined;
            this.hisAppointmentId = _data["hisAppointmentId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientKey"] = this.patientKey;
        data["clinicId"] = this.clinicId;
        data["scheduleSlotId"] = this.scheduleSlotId;
        data["doctorId"] = this.doctorId;
        data["organizationId"] = this.organizationId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["timeband"] = this.timeband;
        data["scope"] = this.scope;
        data["status"] = this.status;
        data["holdExpiresAt"] = this.holdExpiresAt ? this.holdExpiresAt.toISOString() : <any>undefined;
        data["hisAppointmentId"] = this.hisAppointmentId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAppointmentDetailDto {
    id?: number;
    patientKey?: string;
    clinicId?: number;
    scheduleSlotId?: number | undefined;
    doctorId?: number | undefined;
    organizationId?: number | undefined;
    date?: Date;
    timeband?: TimebandCode;
    scope?: BookingScope;
    status?: BookingStatus;
    holdExpiresAt?: Date | undefined;
    hisAppointmentId?: number;
    created?: Date;
    lastModified?: Date;
}

export enum BookingScope {
    Doctor = 1,
    Room = 2,
}

export class OrganizationDto implements IOrganizationDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    created?: Date;
    link?: OrganizationLinkDto | undefined;
    counters?: OrganizationCountersDto;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.link = _data["link"] ? OrganizationLinkDto.fromJS(_data["link"]) : <any>undefined;
            this.counters = _data["counters"] ? OrganizationCountersDto.fromJS(_data["counters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["counters"] = this.counters ? this.counters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    created?: Date;
    link?: OrganizationLinkDto | undefined;
    counters?: OrganizationCountersDto;
}

export class OrganizationLinkDto implements IOrganizationLinkDto {
    id?: number;
    organizationId?: number;
    tokenPrefix?: string | undefined;
    isEnabled?: boolean;
    rotatedAt?: Date | undefined;
    created?: Date;

    constructor(data?: IOrganizationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.tokenPrefix = _data["tokenPrefix"];
            this.isEnabled = _data["isEnabled"];
            this.rotatedAt = _data["rotatedAt"] ? new Date(_data["rotatedAt"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["tokenPrefix"] = this.tokenPrefix;
        data["isEnabled"] = this.isEnabled;
        data["rotatedAt"] = this.rotatedAt ? this.rotatedAt.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationLinkDto {
    id?: number;
    organizationId?: number;
    tokenPrefix?: string | undefined;
    isEnabled?: boolean;
    rotatedAt?: Date | undefined;
    created?: Date;
}

export class OrganizationCountersDto implements IOrganizationCountersDto {
    total?: number;
    pending?: number;
    confirmed?: number;
    completed?: number;
    cancelled?: number;
    noShow?: number;

    constructor(data?: IOrganizationCountersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.pending = _data["pending"];
            this.confirmed = _data["confirmed"];
            this.completed = _data["completed"];
            this.cancelled = _data["cancelled"];
            this.noShow = _data["noShow"];
        }
    }

    static fromJS(data: any): OrganizationCountersDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCountersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["pending"] = this.pending;
        data["confirmed"] = this.confirmed;
        data["completed"] = this.completed;
        data["cancelled"] = this.cancelled;
        data["noShow"] = this.noShow;
        return data;
    }
}

export interface IOrganizationCountersDto {
    total?: number;
    pending?: number;
    confirmed?: number;
    completed?: number;
    cancelled?: number;
    noShow?: number;
}

export class CreateOrganizationCommand implements ICreateOrganizationCommand {
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;

    constructor(data?: ICreateOrganizationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateOrganizationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateOrganizationCommand {
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;
}

export class PaginatedListOfOrganizationDto implements IPaginatedListOfOrganizationDto {
    items?: OrganizationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfOrganizationDto {
    items?: OrganizationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class UpdateOrganizationCommand implements IUpdateOrganizationCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;

    constructor(data?: IUpdateOrganizationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateOrganizationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateOrganizationCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    note?: string | undefined;
}

export class ToggleStatusRequest implements IToggleStatusRequest {
    isActive?: boolean;

    constructor(data?: IToggleStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ToggleStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IToggleStatusRequest {
    isActive?: boolean;
}

export class DeleteOrganizationResult implements IDeleteOrganizationResult {
    mode?: string;

    constructor(data?: IDeleteOrganizationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): DeleteOrganizationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrganizationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        return data;
    }
}

export interface IDeleteOrganizationResult {
    mode?: string;
}

export class OrganizationStatsDto implements IOrganizationStatsDto {
    organizationId?: number;
    organizationName?: string;
    totalRegistrations?: number;
    statusCounts?: { [key: string]: number; };
    breakdown?: OrganizationStatsBucketDto[];
    averageLeadTimeDays?: number | undefined;
    averageProcessingMinutes?: number | undefined;

    constructor(data?: IOrganizationStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.totalRegistrations = _data["totalRegistrations"];
            if (_data["statusCounts"]) {
                this.statusCounts = {} as any;
                for (let key in _data["statusCounts"]) {
                    if (_data["statusCounts"].hasOwnProperty(key))
                        (<any>this.statusCounts)![key] = _data["statusCounts"][key];
                }
            }
            if (Array.isArray(_data["breakdown"])) {
                this.breakdown = [] as any;
                for (let item of _data["breakdown"])
                    this.breakdown!.push(OrganizationStatsBucketDto.fromJS(item));
            }
            this.averageLeadTimeDays = _data["averageLeadTimeDays"];
            this.averageProcessingMinutes = _data["averageProcessingMinutes"];
        }
    }

    static fromJS(data: any): OrganizationStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["totalRegistrations"] = this.totalRegistrations;
        if (this.statusCounts) {
            data["statusCounts"] = {};
            for (let key in this.statusCounts) {
                if (this.statusCounts.hasOwnProperty(key))
                    (<any>data["statusCounts"])[key] = (<any>this.statusCounts)[key];
            }
        }
        if (Array.isArray(this.breakdown)) {
            data["breakdown"] = [];
            for (let item of this.breakdown)
                data["breakdown"].push(item.toJSON());
        }
        data["averageLeadTimeDays"] = this.averageLeadTimeDays;
        data["averageProcessingMinutes"] = this.averageProcessingMinutes;
        return data;
    }
}

export interface IOrganizationStatsDto {
    organizationId?: number;
    organizationName?: string;
    totalRegistrations?: number;
    statusCounts?: { [key: string]: number; };
    breakdown?: OrganizationStatsBucketDto[];
    averageLeadTimeDays?: number | undefined;
    averageProcessingMinutes?: number | undefined;
}

export class OrganizationStatsBucketDto implements IOrganizationStatsBucketDto {
    key?: string;
    count?: number;

    constructor(data?: IOrganizationStatsBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): OrganizationStatsBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationStatsBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        return data;
    }
}

export interface IOrganizationStatsBucketDto {
    key?: string;
    count?: number;
}

export class LoginResponseDto implements ILoginResponseDto {
    accessToken?: string;
    tokenType?: string;
    expiresIn?: number;

    constructor(data?: ILoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.tokenType = _data["tokenType"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): LoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["tokenType"] = this.tokenType;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface ILoginResponseDto {
    accessToken?: string;
    tokenType?: string;
    expiresIn?: number;
}

export class LoginRequest implements ILoginRequest {
    email?: string;
    password?: string;
    twoFactorCode?: string | undefined;
    twoFactorRecoveryCode?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.twoFactorCode = _data["twoFactorCode"];
            this.twoFactorRecoveryCode = _data["twoFactorRecoveryCode"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["twoFactorCode"] = this.twoFactorCode;
        data["twoFactorRecoveryCode"] = this.twoFactorRecoveryCode;
        return data;
    }
}

export interface ILoginRequest {
    email?: string;
    password?: string;
    twoFactorCode?: string | undefined;
    twoFactorRecoveryCode?: string | undefined;
}

export class DoctorWithScheduleDto implements IDoctorWithScheduleDto {
    id?: string;
    name?: string;
    gender?: InferredGender;
    title?: string | undefined;
    formattedTitle?: string | undefined;
    specialtyId?: number | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    workExperience?: string | undefined;
    image?: string | undefined;
    titleDescription?: string | undefined;
    consultationFee?: number | undefined;
    availableDates?: AvailableDateDto[];
    daysThisWeek?: string[];

    constructor(data?: IDoctorWithScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.title = _data["title"];
            this.formattedTitle = _data["formattedTitle"];
            this.specialtyId = _data["specialtyId"];
            this.specialty = _data["specialty"];
            this.position = _data["position"];
            this.workExperience = _data["workExperience"];
            this.image = _data["image"];
            this.titleDescription = _data["titleDescription"];
            this.consultationFee = _data["consultationFee"];
            if (Array.isArray(_data["availableDates"])) {
                this.availableDates = [] as any;
                for (let item of _data["availableDates"])
                    this.availableDates!.push(AvailableDateDto.fromJS(item));
            }
            if (Array.isArray(_data["daysThisWeek"])) {
                this.daysThisWeek = [] as any;
                for (let item of _data["daysThisWeek"])
                    this.daysThisWeek!.push(item);
            }
        }
    }

    static fromJS(data: any): DoctorWithScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorWithScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["title"] = this.title;
        data["formattedTitle"] = this.formattedTitle;
        data["specialtyId"] = this.specialtyId;
        data["specialty"] = this.specialty;
        data["position"] = this.position;
        data["workExperience"] = this.workExperience;
        data["image"] = this.image;
        data["titleDescription"] = this.titleDescription;
        data["consultationFee"] = this.consultationFee;
        if (Array.isArray(this.availableDates)) {
            data["availableDates"] = [];
            for (let item of this.availableDates)
                data["availableDates"].push(item.toJSON());
        }
        if (Array.isArray(this.daysThisWeek)) {
            data["daysThisWeek"] = [];
            for (let item of this.daysThisWeek)
                data["daysThisWeek"].push(item);
        }
        return data;
    }
}

export interface IDoctorWithScheduleDto {
    id?: string;
    name?: string;
    gender?: InferredGender;
    title?: string | undefined;
    formattedTitle?: string | undefined;
    specialtyId?: number | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    workExperience?: string | undefined;
    image?: string | undefined;
    titleDescription?: string | undefined;
    consultationFee?: number | undefined;
    availableDates?: AvailableDateDto[];
    daysThisWeek?: string[];
}

export enum InferredGender {
    Male = 0,
    Female = 1,
    Unknown = 2,
}

export class AvailableDateDto implements IAvailableDateDto {
    date?: string;
    bands?: BandAvailabilityDto[];

    constructor(data?: IAvailableDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            if (Array.isArray(_data["bands"])) {
                this.bands = [] as any;
                for (let item of _data["bands"])
                    this.bands!.push(BandAvailabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        if (Array.isArray(this.bands)) {
            data["bands"] = [];
            for (let item of this.bands)
                data["bands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailableDateDto {
    date?: string;
    bands?: BandAvailabilityDto[];
}

export class BandAvailabilityDto implements IBandAvailabilityDto {
    doctorSlotId?: number | undefined;
    range?: string;
    start?: string;
    end?: string;
    timeband?: TimebandCode;
    unlimited?: boolean;
    capacity?: number | undefined;
    available?: number;

    constructor(data?: IBandAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorSlotId = _data["doctorSlotId"];
            this.range = _data["range"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.timeband = _data["timeband"];
            this.unlimited = _data["unlimited"];
            this.capacity = _data["capacity"];
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): BandAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new BandAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorSlotId"] = this.doctorSlotId;
        data["range"] = this.range;
        data["start"] = this.start;
        data["end"] = this.end;
        data["timeband"] = this.timeband;
        data["unlimited"] = this.unlimited;
        data["capacity"] = this.capacity;
        data["available"] = this.available;
        return data;
    }
}

export interface IBandAvailabilityDto {
    doctorSlotId?: number | undefined;
    range?: string;
    start?: string;
    end?: string;
    timeband?: TimebandCode;
    unlimited?: boolean;
    capacity?: number | undefined;
    available?: number;
}

export class ClinicAvailableSlotDto implements IClinicAvailableSlotDto {
    clinicId?: number;
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    availableDates?: AvailableDateDto[];
    daysThisWeek?: string[];

    constructor(data?: IClinicAvailableSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["availableDates"])) {
                this.availableDates = [] as any;
                for (let item of _data["availableDates"])
                    this.availableDates!.push(AvailableDateDto.fromJS(item));
            }
            if (Array.isArray(_data["daysThisWeek"])) {
                this.daysThisWeek = [] as any;
                for (let item of _data["daysThisWeek"])
                    this.daysThisWeek!.push(item);
            }
        }
    }

    static fromJS(data: any): ClinicAvailableSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicAvailableSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.availableDates)) {
            data["availableDates"] = [];
            for (let item of this.availableDates)
                data["availableDates"].push(item.toJSON());
        }
        if (Array.isArray(this.daysThisWeek)) {
            data["daysThisWeek"] = [];
            for (let item of this.daysThisWeek)
                data["daysThisWeek"].push(item);
        }
        return data;
    }
}

export interface IClinicAvailableSlotDto {
    clinicId?: number;
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    availableDates?: AvailableDateDto[];
    daysThisWeek?: string[];
}

export class UpdateClinicInfoCommand implements IUpdateClinicInfoCommand {
    clinicExtId?: number;
    description?: string | undefined;
    capacity?: number | undefined;

    constructor(data?: IUpdateClinicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicExtId = _data["clinicExtId"];
            this.description = _data["description"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): UpdateClinicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClinicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicExtId"] = this.clinicExtId;
        data["description"] = this.description;
        data["capacity"] = this.capacity;
        return data;
    }
}

export interface IUpdateClinicInfoCommand {
    clinicExtId?: number;
    description?: string | undefined;
    capacity?: number | undefined;
}

export class Result implements IResult {
    succeeded?: boolean;
    errors?: string[];

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IResult {
    succeeded?: boolean;
    errors?: string[];
}

export class ResultOfInteger extends Result implements IResultOfInteger {
    value?: number;

    constructor(data?: IResultOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInteger extends IResult {
    value?: number;
}

export class CreateDoctorAppointmentRequestCommand implements ICreateDoctorAppointmentRequestCommand {
    fullName?: string;
    phone?: string;
    email?: string | undefined;
    doctorId?: string;
    preferredDate?: Date | undefined;
    note?: string | undefined;

    constructor(data?: ICreateDoctorAppointmentRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.doctorId = _data["doctorId"];
            this.preferredDate = _data["preferredDate"] ? new Date(_data["preferredDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateDoctorAppointmentRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDoctorAppointmentRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["doctorId"] = this.doctorId;
        data["preferredDate"] = this.preferredDate ? formatDate(this.preferredDate) : <any>undefined;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateDoctorAppointmentRequestCommand {
    fullName?: string;
    phone?: string;
    email?: string | undefined;
    doctorId?: string;
    preferredDate?: Date | undefined;
    note?: string | undefined;
}

export class DoctorAppointmentRequestDto implements IDoctorAppointmentRequestDto {
    id?: number;
    fullName?: string;
    phone?: string;
    email?: string | undefined;
    doctorId?: string;
    doctorName?: string;
    preferredDate?: Date | undefined;
    actualAppointmentDate?: Date | undefined;
    note?: string | undefined;
    status?: AppointmentRequestStatus;
    created?: Date;

    constructor(data?: IDoctorAppointmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
            this.preferredDate = _data["preferredDate"] ? new Date(_data["preferredDate"].toString()) : <any>undefined;
            this.actualAppointmentDate = _data["actualAppointmentDate"] ? new Date(_data["actualAppointmentDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DoctorAppointmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorAppointmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        data["preferredDate"] = this.preferredDate ? formatDate(this.preferredDate) : <any>undefined;
        data["actualAppointmentDate"] = this.actualAppointmentDate ? this.actualAppointmentDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDoctorAppointmentRequestDto {
    id?: number;
    fullName?: string;
    phone?: string;
    email?: string | undefined;
    doctorId?: string;
    doctorName?: string;
    preferredDate?: Date | undefined;
    actualAppointmentDate?: Date | undefined;
    note?: string | undefined;
    status?: AppointmentRequestStatus;
    created?: Date;
}

export enum AppointmentRequestStatus {
    New = 1,
    Contacted = 2,
    Scheduled = 3,
    Cancelled = 4,
}

export class UpdateDoctorAppointmentRequestStatusCommand implements IUpdateDoctorAppointmentRequestStatusCommand {
    id?: number;
    status?: AppointmentRequestStatus;
    actualAppointmentDate?: Date | undefined;

    constructor(data?: IUpdateDoctorAppointmentRequestStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.actualAppointmentDate = _data["actualAppointmentDate"] ? new Date(_data["actualAppointmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDoctorAppointmentRequestStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorAppointmentRequestStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["actualAppointmentDate"] = this.actualAppointmentDate ? this.actualAppointmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateDoctorAppointmentRequestStatusCommand {
    id?: number;
    status?: AppointmentRequestStatus;
    actualAppointmentDate?: Date | undefined;
}

export class UpdateActualAppointmentDateCommand implements IUpdateActualAppointmentDateCommand {
    id?: number;
    actualAppointmentDate?: Date | undefined;

    constructor(data?: IUpdateActualAppointmentDateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actualAppointmentDate = _data["actualAppointmentDate"] ? new Date(_data["actualAppointmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateActualAppointmentDateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActualAppointmentDateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actualAppointmentDate"] = this.actualAppointmentDate ? this.actualAppointmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateActualAppointmentDateCommand {
    id?: number;
    actualAppointmentDate?: Date | undefined;
}

export class CreateDoctorTitleCommand implements ICreateDoctorTitleCommand {
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: ICreateDoctorTitleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.fee = _data["fee"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateDoctorTitleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDoctorTitleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["fee"] = this.fee;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateDoctorTitleCommand {
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;
}

export class UpdateDoctorTitleCommand implements IUpdateDoctorTitleCommand {
    id?: number;
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IUpdateDoctorTitleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.fee = _data["fee"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateDoctorTitleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorTitleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fee"] = this.fee;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateDoctorTitleCommand {
    id?: number;
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;
}

export class UpsertDoctorProfileSettingCommand implements IUpsertDoctorProfileSettingCommand {
    doctorId?: string;
    doctorTitleId?: number | undefined;
    summary?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUpsertDoctorProfileSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.doctorTitleId = _data["doctorTitleId"];
            this.summary = _data["summary"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpsertDoctorProfileSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDoctorProfileSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["doctorTitleId"] = this.doctorTitleId;
        data["summary"] = this.summary;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpsertDoctorProfileSettingCommand {
    doctorId?: string;
    doctorTitleId?: number | undefined;
    summary?: string | undefined;
    isActive?: boolean;
}

export class DoctorsResponseDto implements IDoctorsResponseDto {
    batchId?: string;
    doctors?: DoctorDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    hasNextPage?: boolean;

    constructor(data?: IDoctorsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(DoctorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): DoctorsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IDoctorsResponseDto {
    batchId?: string;
    doctors?: DoctorDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    hasNextPage?: boolean;
}

export class DoctorDto implements IDoctorDto {
    doctorId?: string;
    name?: string;
    gender?: InferredGender;
    title?: string | undefined;
    formattedTitle?: string | undefined;
    specialtyId?: number | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    workExperience?: string | undefined;
    originalUrl?: string;
    processedUrl?: string | undefined;
    titleDescription?: string | undefined;
    description?: SectionDto[];
    daysThisWeek?: string[];
    avatarStatus?: string;
    resolved?: PositionPriorityResult | undefined;
    summary?: string | undefined;
    consultationFee?: number | undefined;
    doctorTitleId?: number | undefined;
    hasCustomImage?: boolean;

    constructor(data?: IDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.title = _data["title"];
            this.formattedTitle = _data["formattedTitle"];
            this.specialtyId = _data["specialtyId"];
            this.specialty = _data["specialty"];
            this.position = _data["position"];
            this.workExperience = _data["workExperience"];
            this.originalUrl = _data["originalUrl"];
            this.processedUrl = _data["processedUrl"];
            this.titleDescription = _data["titleDescription"];
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(SectionDto.fromJS(item));
            }
            if (Array.isArray(_data["daysThisWeek"])) {
                this.daysThisWeek = [] as any;
                for (let item of _data["daysThisWeek"])
                    this.daysThisWeek!.push(item);
            }
            this.avatarStatus = _data["avatarStatus"];
            this.resolved = _data["resolved"] ? PositionPriorityResult.fromJS(_data["resolved"]) : <any>undefined;
            this.summary = _data["summary"];
            this.consultationFee = _data["consultationFee"];
            this.doctorTitleId = _data["doctorTitleId"];
            this.hasCustomImage = _data["hasCustomImage"];
        }
    }

    static fromJS(data: any): DoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["title"] = this.title;
        data["formattedTitle"] = this.formattedTitle;
        data["specialtyId"] = this.specialtyId;
        data["specialty"] = this.specialty;
        data["position"] = this.position;
        data["workExperience"] = this.workExperience;
        data["originalUrl"] = this.originalUrl;
        data["processedUrl"] = this.processedUrl;
        data["titleDescription"] = this.titleDescription;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        if (Array.isArray(this.daysThisWeek)) {
            data["daysThisWeek"] = [];
            for (let item of this.daysThisWeek)
                data["daysThisWeek"].push(item);
        }
        data["avatarStatus"] = this.avatarStatus;
        data["resolved"] = this.resolved ? this.resolved.toJSON() : <any>undefined;
        data["summary"] = this.summary;
        data["consultationFee"] = this.consultationFee;
        data["doctorTitleId"] = this.doctorTitleId;
        data["hasCustomImage"] = this.hasCustomImage;
        return data;
    }
}

export interface IDoctorDto {
    doctorId?: string;
    name?: string;
    gender?: InferredGender;
    title?: string | undefined;
    formattedTitle?: string | undefined;
    specialtyId?: number | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    workExperience?: string | undefined;
    originalUrl?: string;
    processedUrl?: string | undefined;
    titleDescription?: string | undefined;
    description?: SectionDto[];
    daysThisWeek?: string[];
    avatarStatus?: string;
    resolved?: PositionPriorityResult | undefined;
    summary?: string | undefined;
    consultationFee?: number | undefined;
    doctorTitleId?: number | undefined;
    hasCustomImage?: boolean;
}

export class SectionDto implements ISectionDto {
    title?: string;
    items?: string[];

    constructor(data?: ISectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): SectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface ISectionDto {
    title?: string;
    items?: string[];
}

export class PositionPriorityResult implements IPositionPriorityResult {
    basePriority?: number;
    bonus?: number;
    totalPriority?: number;
    matchedRole?: string;
    matchedBonuses?: string[];
    normalizedText?: string;

    constructor(data?: IPositionPriorityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basePriority = _data["basePriority"];
            this.bonus = _data["bonus"];
            this.totalPriority = _data["totalPriority"];
            this.matchedRole = _data["matchedRole"];
            if (Array.isArray(_data["matchedBonuses"])) {
                this.matchedBonuses = [] as any;
                for (let item of _data["matchedBonuses"])
                    this.matchedBonuses!.push(item);
            }
            this.normalizedText = _data["normalizedText"];
        }
    }

    static fromJS(data: any): PositionPriorityResult {
        data = typeof data === 'object' ? data : {};
        let result = new PositionPriorityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basePriority"] = this.basePriority;
        data["bonus"] = this.bonus;
        data["totalPriority"] = this.totalPriority;
        data["matchedRole"] = this.matchedRole;
        if (Array.isArray(this.matchedBonuses)) {
            data["matchedBonuses"] = [];
            for (let item of this.matchedBonuses)
                data["matchedBonuses"].push(item);
        }
        data["normalizedText"] = this.normalizedText;
        return data;
    }
}

export interface IPositionPriorityResult {
    basePriority?: number;
    bonus?: number;
    totalPriority?: number;
    matchedRole?: string;
    matchedBonuses?: string[];
    normalizedText?: string;
}

export class DoctorScheduleClinicDto implements IDoctorScheduleClinicDto {
    doctorId?: string;
    doctorName?: string;
    title?: string | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    image?: string | undefined;
    consultationFee?: number | undefined;
    availableClinics?: ClinicAvailableSlotDto[];

    constructor(data?: IDoctorScheduleClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
            this.title = _data["title"];
            this.specialty = _data["specialty"];
            this.position = _data["position"];
            this.image = _data["image"];
            this.consultationFee = _data["consultationFee"];
            if (Array.isArray(_data["availableClinics"])) {
                this.availableClinics = [] as any;
                for (let item of _data["availableClinics"])
                    this.availableClinics!.push(ClinicAvailableSlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoctorScheduleClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorScheduleClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        data["title"] = this.title;
        data["specialty"] = this.specialty;
        data["position"] = this.position;
        data["image"] = this.image;
        data["consultationFee"] = this.consultationFee;
        if (Array.isArray(this.availableClinics)) {
            data["availableClinics"] = [];
            for (let item of this.availableClinics)
                data["availableClinics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoctorScheduleClinicDto {
    doctorId?: string;
    doctorName?: string;
    title?: string | undefined;
    specialty?: string | undefined;
    position?: string | undefined;
    image?: string | undefined;
    consultationFee?: number | undefined;
    availableClinics?: ClinicAvailableSlotDto[];
}

export class DoctorTitleOptionDto implements IDoctorTitleOptionDto {
    id?: number;
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IDoctorTitleOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.fee = _data["fee"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DoctorTitleOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorTitleOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fee"] = this.fee;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IDoctorTitleOptionDto {
    id?: number;
    code?: string;
    name?: string;
    fee?: number;
    sortOrder?: number;
    isActive?: boolean;
}

export class LookupBundleDto implements ILookupBundleDto {
    jobs?: JobDto[];
    provinces?: ProvinceDto[];
    ethnicities?: EthnicityDto[];

    constructor(data?: ILookupBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(JobDto.fromJS(item));
            }
            if (Array.isArray(_data["provinces"])) {
                this.provinces = [] as any;
                for (let item of _data["provinces"])
                    this.provinces!.push(ProvinceDto.fromJS(item));
            }
            if (Array.isArray(_data["ethnicities"])) {
                this.ethnicities = [] as any;
                for (let item of _data["ethnicities"])
                    this.ethnicities!.push(EthnicityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LookupBundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupBundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        if (Array.isArray(this.provinces)) {
            data["provinces"] = [];
            for (let item of this.provinces)
                data["provinces"].push(item.toJSON());
        }
        if (Array.isArray(this.ethnicities)) {
            data["ethnicities"] = [];
            for (let item of this.ethnicities)
                data["ethnicities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILookupBundleDto {
    jobs?: JobDto[];
    provinces?: ProvinceDto[];
    ethnicities?: EthnicityDto[];
}

export class JobDto implements IJobDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IJobDto {
    id?: number;
    name?: string | undefined;
}

export class ProvinceDto implements IProvinceDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProvinceDto {
    id?: number;
    name?: string | undefined;
}

export class EthnicityDto implements IEthnicityDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEthnicityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EthnicityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EthnicityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEthnicityDto {
    id?: number;
    name?: string | undefined;
}

export class DistrictDto implements IDistrictDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDistrictDto {
    id?: number;
    name?: string | undefined;
}

export class WardDto implements IWardDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IWardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WardDto {
        data = typeof data === 'object' ? data : {};
        let result = new WardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWardDto {
    id?: number;
    name?: string | undefined;
}

export class RevisitDto implements IRevisitDto {
    fullName?: string;
    dateOfBirth?: string;
    gender?: string | undefined;
    nationalId?: string | undefined;
    ethnicityCode?: number;
    occupationCode?: number;
    phone?: string | undefined;
    provinceCode?: number;
    districtCode?: number;
    wardCode?: number;
    addressDetail?: string | undefined;

    constructor(data?: IRevisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
            this.nationalId = _data["nationalId"];
            this.ethnicityCode = _data["ethnicityCode"];
            this.occupationCode = _data["occupationCode"];
            this.phone = _data["phone"];
            this.provinceCode = _data["provinceCode"];
            this.districtCode = _data["districtCode"];
            this.wardCode = _data["wardCode"];
            this.addressDetail = _data["addressDetail"];
        }
    }

    static fromJS(data: any): RevisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        data["nationalId"] = this.nationalId;
        data["ethnicityCode"] = this.ethnicityCode;
        data["occupationCode"] = this.occupationCode;
        data["phone"] = this.phone;
        data["provinceCode"] = this.provinceCode;
        data["districtCode"] = this.districtCode;
        data["wardCode"] = this.wardCode;
        data["addressDetail"] = this.addressDetail;
        return data;
    }
}

export interface IRevisitDto {
    fullName?: string;
    dateOfBirth?: string;
    gender?: string | undefined;
    nationalId?: string | undefined;
    ethnicityCode?: number;
    occupationCode?: number;
    phone?: string | undefined;
    provinceCode?: number;
    districtCode?: number;
    wardCode?: number;
    addressDetail?: string | undefined;
}

export class SearchRevisitQuery implements ISearchRevisitQuery {
    captcha?: string;
    captchaScope?: string;
    patientCode?: string;

    constructor(data?: ISearchRevisitQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.captchaScope = _data["captchaScope"];
            this.patientCode = _data["patientCode"];
        }
    }

    static fromJS(data: any): SearchRevisitQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRevisitQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["captchaScope"] = this.captchaScope;
        data["patientCode"] = this.patientCode;
        return data;
    }
}

export interface ISearchRevisitQuery {
    captcha?: string;
    captchaScope?: string;
    patientCode?: string;
}

export class OrganizationLinkResolveDto implements IOrganizationLinkResolveDto {
    organizationId?: number;
    organizationName?: string;
    organizationCode?: string | undefined;

    constructor(data?: IOrganizationLinkResolveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.organizationCode = _data["organizationCode"];
        }
    }

    static fromJS(data: any): OrganizationLinkResolveDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationLinkResolveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["organizationCode"] = this.organizationCode;
        return data;
    }
}

export interface IOrganizationLinkResolveDto {
    organizationId?: number;
    organizationName?: string;
    organizationCode?: string | undefined;
}

export class TimeRangeSlotDto implements ITimeRangeSlotDto {
    clinicId?: number;
    clinicExtId?: number;
    localDate?: Date;
    startTime?: Date;
    endTime?: Date;
    status?: string | undefined;
    doctors?: ScheduleSlotDto[];

    constructor(data?: ITimeRangeSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.clinicExtId = _data["clinicExtId"];
            this.localDate = _data["localDate"] ? new Date(_data["localDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(ScheduleSlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeRangeSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRangeSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["clinicExtId"] = this.clinicExtId;
        data["localDate"] = this.localDate ? formatDate(this.localDate) : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeRangeSlotDto {
    clinicId?: number;
    clinicExtId?: number;
    localDate?: Date;
    startTime?: Date;
    endTime?: Date;
    status?: string | undefined;
    doctors?: ScheduleSlotDto[];
}

export class ScheduleSlotDto implements IScheduleSlotDto {
    id?: number;
    doctorId?: number;
    clinicId?: number;
    doctorExtId?: string;
    clinicExtId?: number;
    startTime?: Date;
    endTime?: Date;
    capacity?: number;
    bookedCount?: number;
    status?: SlotStatus;

    constructor(data?: IScheduleSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.doctorId = _data["doctorId"];
            this.clinicId = _data["clinicId"];
            this.doctorExtId = _data["doctorExtId"];
            this.clinicExtId = _data["clinicExtId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.capacity = _data["capacity"];
            this.bookedCount = _data["bookedCount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ScheduleSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["doctorId"] = this.doctorId;
        data["clinicId"] = this.clinicId;
        data["doctorExtId"] = this.doctorExtId;
        data["clinicExtId"] = this.clinicExtId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["capacity"] = this.capacity;
        data["bookedCount"] = this.bookedCount;
        data["status"] = this.status;
        return data;
    }
}

export interface IScheduleSlotDto {
    id?: number;
    doctorId?: number;
    clinicId?: number;
    doctorExtId?: string;
    clinicExtId?: number;
    startTime?: Date;
    endTime?: Date;
    capacity?: number;
    bookedCount?: number;
    status?: SlotStatus;
}

export enum SlotStatus {
    AVAILABLE = 0,
    WARNING = 1,
    FULL = 2,
    BLOCKED = 3,
}

export class CreateScheduleSlotCommand implements ICreateScheduleSlotCommand {
    clinicId?: number | undefined;
    clinicExtId?: number;
    dates?: string[];
    startTime?: string;
    endTime?: string;
    doctors?: CreateScheduleSlotDoctorItem[];

    constructor(data?: ICreateScheduleSlotCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.clinicExtId = _data["clinicExtId"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(CreateScheduleSlotDoctorItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateScheduleSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["clinicExtId"] = this.clinicExtId;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateScheduleSlotCommand {
    clinicId?: number | undefined;
    clinicExtId?: number;
    dates?: string[];
    startTime?: string;
    endTime?: string;
    doctors?: CreateScheduleSlotDoctorItem[];
}

export class CreateScheduleSlotDoctorItem implements ICreateScheduleSlotDoctorItem {
    doctorExtId?: string;
    quota?: number;

    constructor(data?: ICreateScheduleSlotDoctorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorExtId = _data["doctorExtId"];
            this.quota = _data["quota"];
        }
    }

    static fromJS(data: any): CreateScheduleSlotDoctorItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleSlotDoctorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorExtId"] = this.doctorExtId;
        data["quota"] = this.quota;
        return data;
    }
}

export interface ICreateScheduleSlotDoctorItem {
    doctorExtId?: string;
    quota?: number;
}

export class UpdateScheduleSlotCommand implements IUpdateScheduleSlotCommand {
    doctorExtId?: string | undefined;
    localDate?: string | undefined;
    capacity?: number;
    status?: string;

    constructor(data?: IUpdateScheduleSlotCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorExtId = _data["doctorExtId"];
            this.localDate = _data["localDate"];
            this.capacity = _data["capacity"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateScheduleSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorExtId"] = this.doctorExtId;
        data["localDate"] = this.localDate;
        data["capacity"] = this.capacity;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateScheduleSlotCommand {
    doctorExtId?: string | undefined;
    localDate?: string | undefined;
    capacity?: number;
    status?: string;
}

export class CheckScheduleConflictQuery implements ICheckScheduleConflictQuery {
    clinicExtId?: number;
    doctorExtId?: string;
    dates?: string[];
    startTime?: string;
    endTime?: string;

    constructor(data?: ICheckScheduleConflictQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicExtId = _data["clinicExtId"];
            this.doctorExtId = _data["doctorExtId"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): CheckScheduleConflictQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckScheduleConflictQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicExtId"] = this.clinicExtId;
        data["doctorExtId"] = this.doctorExtId;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface ICheckScheduleConflictQuery {
    clinicExtId?: number;
    doctorExtId?: string;
    dates?: string[];
    startTime?: string;
    endTime?: string;
}

export class UpdateScheduleSlotTimeRangeCommand implements IUpdateScheduleSlotTimeRangeCommand {
    clinicExtId?: number;
    localDate?: string;
    oldStartTime?: string;
    oldEndTime?: string;
    newStartTime?: string;
    newEndTime?: string;

    constructor(data?: IUpdateScheduleSlotTimeRangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicExtId = _data["clinicExtId"];
            this.localDate = _data["localDate"];
            this.oldStartTime = _data["oldStartTime"];
            this.oldEndTime = _data["oldEndTime"];
            this.newStartTime = _data["newStartTime"];
            this.newEndTime = _data["newEndTime"];
        }
    }

    static fromJS(data: any): UpdateScheduleSlotTimeRangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleSlotTimeRangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicExtId"] = this.clinicExtId;
        data["localDate"] = this.localDate;
        data["oldStartTime"] = this.oldStartTime;
        data["oldEndTime"] = this.oldEndTime;
        data["newStartTime"] = this.newStartTime;
        data["newEndTime"] = this.newEndTime;
        return data;
    }
}

export interface IUpdateScheduleSlotTimeRangeCommand {
    clinicExtId?: number;
    localDate?: string;
    oldStartTime?: string;
    oldEndTime?: string;
    newStartTime?: string;
    newEndTime?: string;
}

export class UpdateScheduleSlotTimeRangeStatusCommand implements IUpdateScheduleSlotTimeRangeStatusCommand {
    clinicId?: number;
    localDate?: string;
    startTime?: string;
    endTime?: string;
    status?: string;

    constructor(data?: IUpdateScheduleSlotTimeRangeStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.localDate = _data["localDate"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateScheduleSlotTimeRangeStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleSlotTimeRangeStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["localDate"] = this.localDate;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateScheduleSlotTimeRangeStatusCommand {
    clinicId?: number;
    localDate?: string;
    startTime?: string;
    endTime?: string;
    status?: string;
}

export class DeleteScheduleSlotTimeRangeCommand implements IDeleteScheduleSlotTimeRangeCommand {
    clinicId?: number;
    localDate?: string;
    startTime?: string;
    endTime?: string;

    constructor(data?: IDeleteScheduleSlotTimeRangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.localDate = _data["localDate"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): DeleteScheduleSlotTimeRangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScheduleSlotTimeRangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["localDate"] = this.localDate;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface IDeleteScheduleSlotTimeRangeCommand {
    clinicId?: number;
    localDate?: string;
    startTime?: string;
    endTime?: string;
}

export class CreateSpecialtyCommand implements ICreateSpecialtyCommand {
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;

    constructor(data?: ICreateSpecialtyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateSpecialtyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialtyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ICreateSpecialtyCommand {
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;
}

export class UpdateSpecialtyCommand implements IUpdateSpecialtyCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;

    constructor(data?: IUpdateSpecialtyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): UpdateSpecialtyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecialtyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IUpdateSpecialtyCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;
}

export class UpdateDoctorSpecialtyCommand implements IUpdateDoctorSpecialtyCommand {
    doctorId?: string;
    specialtyId?: number | undefined;

    constructor(data?: IUpdateDoctorSpecialtyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.specialtyId = _data["specialtyId"];
        }
    }

    static fromJS(data: any): UpdateDoctorSpecialtyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorSpecialtyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["specialtyId"] = this.specialtyId;
        return data;
    }
}

export interface IUpdateDoctorSpecialtyCommand {
    doctorId?: string;
    specialtyId?: number | undefined;
}

export class ClinicScheduleStatusDto implements IClinicScheduleStatusDto {
    clinicId?: number;
    clinicName?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    color?: string;
    hasAnySchedule?: boolean;
    hasDoctorSchedule?: boolean;
    totalSlots?: number;
    doctorSlots?: number;
    dates?: Date[];

    constructor(data?: IClinicScheduleStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.clinicName = _data["clinicName"];
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.hasAnySchedule = _data["hasAnySchedule"];
            this.hasDoctorSchedule = _data["hasDoctorSchedule"];
            this.totalSlots = _data["totalSlots"];
            this.doctorSlots = _data["doctorSlots"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): ClinicScheduleStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicScheduleStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["clinicName"] = this.clinicName;
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["color"] = this.color;
        data["hasAnySchedule"] = this.hasAnySchedule;
        data["hasDoctorSchedule"] = this.hasDoctorSchedule;
        data["totalSlots"] = this.totalSlots;
        data["doctorSlots"] = this.doctorSlots;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(formatDate(item));
        }
        return data;
    }
}

export interface IClinicScheduleStatusDto {
    clinicId?: number;
    clinicName?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    color?: string;
    hasAnySchedule?: boolean;
    hasDoctorSchedule?: boolean;
    totalSlots?: number;
    doctorSlots?: number;
    dates?: Date[];
}

export class ClinicsResponseDto implements IClinicsResponseDto {
    clinics?: ClinicScheduleStatusDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    hasNextPage?: boolean;

    constructor(data?: IClinicsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinics"])) {
                this.clinics = [] as any;
                for (let item of _data["clinics"])
                    this.clinics!.push(ClinicScheduleStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): ClinicsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinics)) {
            data["clinics"] = [];
            for (let item of this.clinics)
                data["clinics"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IClinicsResponseDto {
    clinics?: ClinicScheduleStatusDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    hasNextPage?: boolean;
}

export class SpecialtyDto implements ISpecialtyDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;

    constructor(data?: ISpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISpecialtyDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    displayOrder?: number;
}

export class CreateTicketCommand implements ICreateTicketCommand {
    captcha?: string;
    captchaScope?: string;
    booking?: BookingInfo;
    patient?: PatientInfo;
    organizationToken?: string | undefined;

    constructor(data?: ICreateTicketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.captchaScope = _data["captchaScope"];
            this.booking = _data["booking"] ? BookingInfo.fromJS(_data["booking"]) : <any>undefined;
            this.patient = _data["patient"] ? PatientInfo.fromJS(_data["patient"]) : <any>undefined;
            this.organizationToken = _data["organizationToken"];
        }
    }

    static fromJS(data: any): CreateTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["captchaScope"] = this.captchaScope;
        data["booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["organizationToken"] = this.organizationToken;
        return data;
    }
}

export interface ICreateTicketCommand {
    captcha?: string;
    captchaScope?: string;
    booking?: BookingInfo;
    patient?: PatientInfo;
    organizationToken?: string | undefined;
}

export class BookingInfo implements IBookingInfo {
    clinicId?: number;
    doctorId?: string;
    scheduleSlotId?: number;
    timebandCode?: TimebandCode;
    appointmentDate?: string;
    appointmentTime?: string;
    reasonForVisit?: string;
    session?: string | undefined;
    scoped?: string;

    constructor(data?: IBookingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.doctorId = _data["doctorId"];
            this.scheduleSlotId = _data["scheduleSlotId"];
            this.timebandCode = _data["timebandCode"];
            this.appointmentDate = _data["appointmentDate"];
            this.appointmentTime = _data["appointmentTime"];
            this.reasonForVisit = _data["reasonForVisit"];
            this.session = _data["session"];
            this.scoped = _data["scoped"];
        }
    }

    static fromJS(data: any): BookingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BookingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["doctorId"] = this.doctorId;
        data["scheduleSlotId"] = this.scheduleSlotId;
        data["timebandCode"] = this.timebandCode;
        data["appointmentDate"] = this.appointmentDate;
        data["appointmentTime"] = this.appointmentTime;
        data["reasonForVisit"] = this.reasonForVisit;
        data["session"] = this.session;
        data["scoped"] = this.scoped;
        return data;
    }
}

export interface IBookingInfo {
    clinicId?: number;
    doctorId?: string;
    scheduleSlotId?: number;
    timebandCode?: TimebandCode;
    appointmentDate?: string;
    appointmentTime?: string;
    reasonForVisit?: string;
    session?: string | undefined;
    scoped?: string;
}

export class PatientInfo implements IPatientInfo {
    fullName?: string;
    dateOfBirth?: string;
    gender?: string;
    nationalId?: string | undefined;
    ethnicity?: string;
    occupation?: string;
    phoneNumber?: string;
    provinceCode?: string;
    districtCode?: string | undefined;
    wardCode?: string | undefined;
    addressDetail?: string | undefined;

    constructor(data?: IPatientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
            this.nationalId = _data["nationalId"];
            this.ethnicity = _data["ethnicity"];
            this.occupation = _data["occupation"];
            this.phoneNumber = _data["phoneNumber"];
            this.provinceCode = _data["provinceCode"];
            this.districtCode = _data["districtCode"];
            this.wardCode = _data["wardCode"];
            this.addressDetail = _data["addressDetail"];
        }
    }

    static fromJS(data: any): PatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        data["nationalId"] = this.nationalId;
        data["ethnicity"] = this.ethnicity;
        data["occupation"] = this.occupation;
        data["phoneNumber"] = this.phoneNumber;
        data["provinceCode"] = this.provinceCode;
        data["districtCode"] = this.districtCode;
        data["wardCode"] = this.wardCode;
        data["addressDetail"] = this.addressDetail;
        return data;
    }
}

export interface IPatientInfo {
    fullName?: string;
    dateOfBirth?: string;
    gender?: string;
    nationalId?: string | undefined;
    ethnicity?: string;
    occupation?: string;
    phoneNumber?: string;
    provinceCode?: string;
    districtCode?: string | undefined;
    wardCode?: string | undefined;
    addressDetail?: string | undefined;
}

export class SearchTicketView implements ISearchTicketView {
    items?: TicketDto[];
    expiresAt?: Date;
    serverTime?: Date;

    constructor(data?: ISearchTicketView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketDto.fromJS(item));
            }
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.serverTime = _data["serverTime"] ? new Date(_data["serverTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchTicketView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTicketView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchTicketView {
    items?: TicketDto[];
    expiresAt?: Date;
    serverTime?: Date;
}

export class TicketDto implements ITicketDto {
    ticketId?: string;
    appointmentId?: number | undefined;
    fullName?: string;
    dateOfBirth?: string;
    phoneNumber?: string | undefined;
    clinicRoomId?: number;
    clinicName?: string | undefined;
    appointmentDate?: string;
    appointmentTime?: string;
    doctorName?: string | undefined;
    reasonForVisit?: string | undefined;
    departmentCode?: string;
    formattedDepartmentName?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.appointmentId = _data["appointmentId"];
            this.fullName = _data["fullName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.phoneNumber = _data["phoneNumber"];
            this.clinicRoomId = _data["clinicRoomId"];
            this.clinicName = _data["clinicName"];
            this.appointmentDate = _data["appointmentDate"];
            this.appointmentTime = _data["appointmentTime"];
            this.doctorName = _data["doctorName"];
            this.reasonForVisit = _data["reasonForVisit"];
            this.departmentCode = _data["departmentCode"];
            this.formattedDepartmentName = _data["formattedDepartmentName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["appointmentId"] = this.appointmentId;
        data["fullName"] = this.fullName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["phoneNumber"] = this.phoneNumber;
        data["clinicRoomId"] = this.clinicRoomId;
        data["clinicName"] = this.clinicName;
        data["appointmentDate"] = this.appointmentDate;
        data["appointmentTime"] = this.appointmentTime;
        data["doctorName"] = this.doctorName;
        data["reasonForVisit"] = this.reasonForVisit;
        data["departmentCode"] = this.departmentCode;
        data["formattedDepartmentName"] = this.formattedDepartmentName;
        data["status"] = this.status;
        return data;
    }
}

export interface ITicketDto {
    ticketId?: string;
    appointmentId?: number | undefined;
    fullName?: string;
    dateOfBirth?: string;
    phoneNumber?: string | undefined;
    clinicRoomId?: number;
    clinicName?: string | undefined;
    appointmentDate?: string;
    appointmentTime?: string;
    doctorName?: string | undefined;
    reasonForVisit?: string | undefined;
    departmentCode?: string;
    formattedDepartmentName?: string | undefined;
    status?: string | undefined;
}

export class SearchTicketQuery implements ISearchTicketQuery {
    dateFrom?: string;
    dateTo?: string;
    phone?: string;
    captcha?: string;
    captchaScope?: string;

    constructor(data?: ISearchTicketQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.phone = _data["phone"];
            this.captcha = _data["captcha"];
            this.captchaScope = _data["captchaScope"];
        }
    }

    static fromJS(data: any): SearchTicketQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTicketQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["phone"] = this.phone;
        data["captcha"] = this.captcha;
        data["captchaScope"] = this.captchaScope;
        return data;
    }
}

export interface ISearchTicketQuery {
    dateFrom?: string;
    dateTo?: string;
    phone?: string;
    captcha?: string;
    captchaScope?: string;
}

export class AccessDefinitionDto implements IAccessDefinitionDto {
    roles?: RoleDefinitionDto[];
    permissions?: PermissionDefinitionDto[];

    constructor(data?: IAccessDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccessDefinitionDto {
    roles?: RoleDefinitionDto[];
    permissions?: PermissionDefinitionDto[];
}

export class RoleDefinitionDto implements IRoleDefinitionDto {
    name?: string;
    displayName?: string;
    description?: string;

    constructor(data?: IRoleDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IRoleDefinitionDto {
    name?: string;
    displayName?: string;
    description?: string;
}

export class PermissionDefinitionDto implements IPermissionDefinitionDto {
    key?: string;
    displayName?: string;
    group?: string;
    description?: string | undefined;

    constructor(data?: IPermissionDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.group = _data["group"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["group"] = this.group;
        data["description"] = this.description;
        return data;
    }
}

export interface IPermissionDefinitionDto {
    key?: string;
    displayName?: string;
    group?: string;
    description?: string | undefined;
}

export class UserAccessDto implements IUserAccessDto {
    userId?: string;
    userName?: string;
    roles?: string[];
    rolePermissions?: string[];
    userGrants?: string[];
    userDenies?: string[];
    effectivePermissions?: string[];

    constructor(data?: IUserAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(item);
            }
            if (Array.isArray(_data["userGrants"])) {
                this.userGrants = [] as any;
                for (let item of _data["userGrants"])
                    this.userGrants!.push(item);
            }
            if (Array.isArray(_data["userDenies"])) {
                this.userDenies = [] as any;
                for (let item of _data["userDenies"])
                    this.userDenies!.push(item);
            }
            if (Array.isArray(_data["effectivePermissions"])) {
                this.effectivePermissions = [] as any;
                for (let item of _data["effectivePermissions"])
                    this.effectivePermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item);
        }
        if (Array.isArray(this.userGrants)) {
            data["userGrants"] = [];
            for (let item of this.userGrants)
                data["userGrants"].push(item);
        }
        if (Array.isArray(this.userDenies)) {
            data["userDenies"] = [];
            for (let item of this.userDenies)
                data["userDenies"].push(item);
        }
        if (Array.isArray(this.effectivePermissions)) {
            data["effectivePermissions"] = [];
            for (let item of this.effectivePermissions)
                data["effectivePermissions"].push(item);
        }
        return data;
    }
}

export interface IUserAccessDto {
    userId?: string;
    userName?: string;
    roles?: string[];
    rolePermissions?: string[];
    userGrants?: string[];
    userDenies?: string[];
    effectivePermissions?: string[];
}

export class UpdateUserAccessRequest implements IUpdateUserAccessRequest {
    roles?: string[];
    grants?: string[];
    denies?: string[];

    constructor(data?: IUpdateUserAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["grants"])) {
                this.grants = [] as any;
                for (let item of _data["grants"])
                    this.grants!.push(item);
            }
            if (Array.isArray(_data["denies"])) {
                this.denies = [] as any;
                for (let item of _data["denies"])
                    this.denies!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.grants)) {
            data["grants"] = [];
            for (let item of this.grants)
                data["grants"].push(item);
        }
        if (Array.isArray(this.denies)) {
            data["denies"] = [];
            for (let item of this.denies)
                data["denies"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserAccessRequest {
    roles?: string[];
    grants?: string[];
    denies?: string[];
}

export class PaginatedListOfAdminUserSummaryDto implements IPaginatedListOfAdminUserSummaryDto {
    items?: AdminUserSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAdminUserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminUserSummaryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAdminUserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAdminUserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAdminUserSummaryDto {
    items?: AdminUserSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdminUserSummaryDto implements IAdminUserSummaryDto {
    id?: string;
    userName?: string;
    email?: string;
    fullName?: string | undefined;
    roles?: string[];
    permissionCount?: number;
    clinicIds?: number[];

    constructor(data?: IAdminUserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.permissionCount = _data["permissionCount"];
            if (Array.isArray(_data["clinicIds"])) {
                this.clinicIds = [] as any;
                for (let item of _data["clinicIds"])
                    this.clinicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["permissionCount"] = this.permissionCount;
        if (Array.isArray(this.clinicIds)) {
            data["clinicIds"] = [];
            for (let item of this.clinicIds)
                data["clinicIds"].push(item);
        }
        return data;
    }
}

export interface IAdminUserSummaryDto {
    id?: string;
    userName?: string;
    email?: string;
    fullName?: string | undefined;
    roles?: string[];
    permissionCount?: number;
    clinicIds?: number[];
}

export class AdminUserDto implements IAdminUserDto {
    id?: string;
    name?: string;
    email?: string;
    role?: string | undefined;
    status?: string;

    constructor(data?: IAdminUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AdminUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        data["status"] = this.status;
        return data;
    }
}

export interface IAdminUserDto {
    id?: string;
    name?: string;
    email?: string;
    role?: string | undefined;
    status?: string;
}

export class CreateUserRequest implements ICreateUserRequest {
    name?: string;
    email?: string;
    departmentId?: number | undefined;
    role?: string;
    password?: string;
    clinicIds?: number[] | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.departmentId = _data["departmentId"];
            this.role = _data["role"];
            this.password = _data["password"];
            if (Array.isArray(_data["clinicIds"])) {
                this.clinicIds = [] as any;
                for (let item of _data["clinicIds"])
                    this.clinicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["departmentId"] = this.departmentId;
        data["role"] = this.role;
        data["password"] = this.password;
        if (Array.isArray(this.clinicIds)) {
            data["clinicIds"] = [];
            for (let item of this.clinicIds)
                data["clinicIds"].push(item);
        }
        return data;
    }
}

export interface ICreateUserRequest {
    name?: string;
    email?: string;
    departmentId?: number | undefined;
    role?: string;
    password?: string;
    clinicIds?: number[] | undefined;
}

export class UpdateUserRequest implements IUpdateUserRequest {
    name?: string;
    email?: string;
    departmentId?: number | undefined;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["departmentId"] = this.departmentId;
        return data;
    }
}

export interface IUpdateUserRequest {
    name?: string;
    email?: string;
    departmentId?: number | undefined;
}

export class ResetUserPasswordRequest implements IResetUserPasswordRequest {
    newPassword?: string;

    constructor(data?: IResetUserPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetUserPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetUserPasswordRequest {
    newPassword?: string;
}

export class UpdateUserClinicsRequest implements IUpdateUserClinicsRequest {
    clinicIds?: number[];

    constructor(data?: IUpdateUserClinicsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicIds"])) {
                this.clinicIds = [] as any;
                for (let item of _data["clinicIds"])
                    this.clinicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserClinicsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserClinicsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicIds)) {
            data["clinicIds"] = [];
            for (let item of this.clinicIds)
                data["clinicIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserClinicsRequest {
    clinicIds?: number[];
}

export class RoleSummaryDto implements IRoleSummaryDto {
    id?: string;
    name?: string;

    constructor(data?: IRoleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleSummaryDto {
    id?: string;
    name?: string;
}

export class RoleAccessDto implements IRoleAccessDto {
    roleId?: string;
    roleName?: string;
    permissions?: string[];

    constructor(data?: IRoleAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IRoleAccessDto {
    roleId?: string;
    roleName?: string;
    permissions?: string[];
}

export class UpdateRoleAccessRequest implements IUpdateRoleAccessRequest {
    permissions?: string[];

    constructor(data?: IUpdateRoleAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRoleAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IUpdateRoleAccessRequest {
    permissions?: string[];
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}